import { Component, OnInit } from '@angular/core';
import { TableCardComponent } from "../../../shared/components/table-card/table-card.component";
import { GenericCrudService } from '../../../services/generic-crud.service';
import { CourseCall } from '../../../models/CourseCall';
import { NgxSpinnerService } from 'ngx-spinner';
import { SortColumn } from '../../../models/GenericCRUD/SortColumn';
import { ActiveFilter } from '../../../models/GenericCRUD/ActiveFilter';
import { GenericForm, GenericFormField } from '../../../models/GenericCRUD/GenericForm';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../models/GenericCRUD/GenericTable';
import { Filter } from '../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../models/GenericCRUD/GenericCRUD';
import { Paginator } from '../../../models/Paginator';
import { GenericCrudComponent } from '../../../shared/components/generic-crud/generic-crud.component';
import { Course } from '../../../models/Course';
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'app-course-calls',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './course-calls.component.html',
  styleUrl: './course-calls.component.css'
})
export class CourseCallsComponent {



}
